//IP占比
const dark_heading = "#c2c6dc";
export default function echartBar8 () {
    return{

        tooltip: {
            trigger: 'item',
            formatter: '{c}%'
        },
        grid: {
            left: "0px",
            right: "20px",
            bottom: "0",
            containLabel: true,
        },
        xAxis: [
            {
                name: "区域",
                type: 'category',
                data: [],
                axisTick: {
                    alignWithLabel: true,
                },
                splitLine: {
                    show: false,
                },
                axisLabel: {
                    color: dark_heading,
                },
                axisLine: {
                    show: true,
                    color: dark_heading,

                    lineStyle: {
                        color: dark_heading,
                    },
                },
            }
        ],
        yAxis: [
            {
                type: 'value',
                name: "占比",
                axisLabel: {
                    color: dark_heading,
                    formatter: "{value}%",
                },
                axisLine: {
                    show: true,
                    color: dark_heading,

                    lineStyle: {
                        color: dark_heading,
                    },
                },
                interval: 25,
                splitLine: {
                    show: false,
                    interval: "auto",
                },
            }
        ],
        series: [
            {
                name: 'ECharts例子个数统计',
                type: 'bar',
                itemStyle: {
                    normal: {
                        color: function (params) {
                            // build a color map as your need.
                            var colorList = [
                                '#C1232B', '#B5C334', '#FCCE10', '#E87C25', '#27727B',
                                '#FE8463', '#9BCA63', '#FAD860', '#F3A43B', '#60C0DD',
                                '#D7504B', '#C6E579', '#F4E001', '#F0805A', '#26C0C0'
                            ];
                            return colorList[params.dataIndex]
                        },
                        label: {
                            show: true,
                            position: 'top',
                            formatter: '{c}%'　　　　//这是关键，在需要的地方加上就行了
                        }
                    }
                },
                data: [],
            }
        ]
    }
};
